module.exports = __webpack_public_path__ + "static/img/whitetitle2s.307e9313.png";